var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    trigger: 'click hover',
    content: _vm.tooltipText,
    classes: 'new-tooltip',
  }),expression:"{\n    trigger: 'click hover',\n    content: tooltipText,\n    classes: 'new-tooltip',\n  }"}],class:[_vm.css(), _vm.css(null, _vm.type)],on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('AtomIcon',{attrs:{"name":_vm.iconName,"size":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }